/**
 * Bundle waitlist popup — same look as Klaviyo on other PDPs.
 * Native Klaviyo does not bind on bundles (parent still "available"),
 * so we open a matching modal and post to Klaviyo's client BIS API.
 */
(function () {
  var COMPANY_ID = 'KMXpNj';
  var LIST_ID = 'KaXMJC';
  var REVISION = '2024-02-15';
  var API_HOST = 'https://a.klaviyo.com';

  function ensureStyles() {
    var style = document.getElementById('mp-klaviyo-bis-styles');
    if (!style) {
      style = document.createElement('style');
      style.id = 'mp-klaviyo-bis-styles';
      document.head.appendChild(style);
    }
    style.textContent =
      '#mp-klaviyo-bis-modal{' +
      'position:fixed!important;top:0!important;right:0!important;bottom:0!important;left:0!important;' +
      'width:100vw!important;height:100vh!important;' +
      'z-index:2147483646!important;display:none;align-items:center;justify-content:center;' +
      'padding:20px!important;box-sizing:border-box!important;' +
      'background:rgba(0,0,0,0.45)!important;margin:0!important;' +
      'pointer-events:auto;' +
      '}' +
      '#mp-klaviyo-bis-modal.is-open{display:flex!important;}' +
      '#mp-klaviyo-bis-modal[hidden]{display:none!important;}' +
      '#mp-klaviyo-bis-modal .mp-bis-dialog{' +
      'position:relative;z-index:2;width:min(100%,420px);background:#fff!important;color:#222;' +
      'padding:36px 32px 28px;box-sizing:border-box;' +
      'font-family:Helvetica Neue,Helvetica,Arial,sans-serif;' +
      'box-shadow:0 8px 30px rgba(0,0,0,.25);' +
      'pointer-events:auto;' +
      '}' +
      '#mp-klaviyo-bis-modal .mp-bis-close{position:absolute;top:10px;right:14px;border:0;background:transparent;font-size:26px;line-height:1;cursor:pointer;color:#ccc;padding:0;}' +
      '#mp-klaviyo-bis-modal h2{margin:0 0 10px;font-size:20px;line-height:1.3;font-weight:700;text-transform:uppercase;letter-spacing:.02em;color:#222;}' +
      '#mp-klaviyo-bis-modal .mp-bis-body{margin:0 0 20px;font-size:15px;line-height:1.45;color:#222;}' +
      '#mp-klaviyo-bis-modal .mp-bis-email-label{display:block;margin:0 0 8px;font-size:14px;color:#222;}' +
      '#mp-klaviyo-bis-modal input[type=email]{width:100%;box-sizing:border-box;margin:0 0 16px;padding:12px 14px;border:1px solid #000;font-size:15px;color:#222;background:#fff;outline:none;font-family:inherit;}' +
      '#mp-klaviyo-bis-modal input[type=email]::placeholder{color:#999;}' +
      '#mp-klaviyo-bis-modal .mp-bis-newsletter{display:flex;align-items:flex-start;gap:10px;margin:0 0 18px;font-size:14px;color:#222;line-height:1.35;}' +
      '#mp-klaviyo-bis-modal .mp-bis-newsletter input[type=checkbox]{margin-top:2px;width:16px;height:16px;flex-shrink:0;accent-color:#1a73e8;}' +
      '#mp-klaviyo-bis-modal .mp-bis-newsletter label{margin:0;font-size:14px;cursor:pointer;}' +
      '#mp-klaviyo-bis-modal .mp-bis-submit{width:100%;border:0;background:#000;color:#fff;padding:14px 16px;font-size:14px;font-weight:500;letter-spacing:.04em;text-transform:uppercase;cursor:pointer;font-family:inherit;}' +
      '#mp-klaviyo-bis-modal .mp-bis-submit[disabled]{opacity:.6;cursor:wait;}' +
      '#mp-klaviyo-bis-modal .mp-bis-error{color:#C72E2F;background:#fcd6d7;padding:8px 10px;margin:0 0 12px;font-size:14px;}' +
      '#mp-klaviyo-bis-modal .mp-bis-success{color:#1B9500;background:#d3efcd;padding:8px 10px;margin:0 0 12px;font-size:14px;}' +
      /* Do not hide page content — only dim with overlay */ +
      'body.mp-klaviyo-bis-open .product__description,' +
      'body.mp-klaviyo-bis-open .bundle-items-container,' +
      'body.mp-klaviyo-bis-open .bundle-description,' +
      'body.mp-klaviyo-bis-open .product__info-container{visibility:visible!important;opacity:1!important;display:revert!important;}';
  }

  function closeModal() {
    var modal = document.getElementById('mp-klaviyo-bis-modal');
    if (!modal) return;
    modal.hidden = true;
    modal.classList.remove('is-open');
    modal.style.display = 'none';
    document.body.classList.remove('mp-klaviyo-bis-open');
    document.documentElement.classList.remove('mp-klaviyo-bis-open');
  }

  function bindModalEvents(modal) {
    if (modal.dataset.mpBisEvents === '1') return;
    modal.dataset.mpBisEvents = '1';

    modal.addEventListener('click', function (e) {
      if (e.target === modal || (e.target && e.target.getAttribute('data-mp-bis-close') !== null)) {
        closeModal();
      }
    });

    var form = modal.querySelector('form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = modal.querySelector('#mp-bis-email');
      var newsletter = modal.querySelector('#mp-bis-newsletter');
      var errorEl = modal.querySelector('.mp-bis-error');
      var successEl = modal.querySelector('.mp-bis-success');
      var submitBtn = modal.querySelector('.mp-bis-submit');
      var email = (emailInput && emailInput.value ? emailInput.value : '').trim();
      var variantId = modal.dataset.variantId;

      if (errorEl) errorEl.hidden = true;
      if (successEl) successEl.hidden = true;

      if (!/@/.test(email) || !variantId) {
        if (errorEl) {
          errorEl.textContent = 'Please enter a valid email.';
          errorEl.hidden = false;
        }
        return;
      }

      if (submitBtn) submitBtn.disabled = true;

      var headers = {
        'Content-Type': 'application/json',
        revision: REVISION,
        'X-Klaviyo-Onsite': '1',
      };

      fetch(API_HOST + '/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(COMPANY_ID), {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: { email: email },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: '$shopify:::$default:::' + String(variantId),
                },
              },
            },
          },
        }),
      })
        .then(function (res) {
          if (!(res.status === 202 || res.ok)) {
            return res.json().then(function (payload) {
              var detail =
                payload &&
                payload.errors &&
                payload.errors[0] &&
                (payload.errors[0].detail || payload.errors[0].title);
              throw new Error(detail || 'Unable to subscribe. Please try again.');
            });
          }

          if (newsletter && newsletter.checked) {
            fetch(API_HOST + '/client/subscriptions/?company_id=' + encodeURIComponent(COMPANY_ID), {
              method: 'POST',
              headers: headers,
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email,
                          properties: { $source: 'Back in Stock' },
                        },
                      },
                    },
                  },
                  relationships: {
                    list: {
                      data: { type: 'list', id: LIST_ID },
                    },
                  },
                },
              }),
            }).catch(function () {});
          }

          if (successEl) successEl.hidden = false;
          if (emailInput) emailInput.value = '';
        })
        .catch(function (err) {
          if (errorEl) {
            errorEl.textContent = (err && err.message) || 'Unable to subscribe. Please try again.';
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          if (submitBtn) submitBtn.disabled = false;
        });
    });
  }

  function ensureModal() {
    ensureStyles();
    var modal = document.getElementById('mp-klaviyo-bis-modal');
    if (modal && !modal.querySelector('.mp-bis-dialog')) {
      modal.remove();
      modal = null;
    }
    if (!modal) {
      modal = document.createElement('div');
      modal.id = 'mp-klaviyo-bis-modal';
      modal.hidden = true;
      modal.innerHTML =
        '<div class="mp-bis-dialog" role="dialog" aria-modal="true" aria-labelledby="mp-bis-title">' +
        '<button type="button" class="mp-bis-close" data-mp-bis-close aria-label="Close">&times;</button>' +
        '<h2 id="mp-bis-title"></h2>' +
        '<p class="mp-bis-body">We\'ll let you know when this item comes back in stock</p>' +
        '<form>' +
        '<label class="mp-bis-email-label" for="mp-bis-email">Email</label>' +
        '<input id="mp-bis-email" type="email" required autocomplete="email" placeholder="Email">' +
        '<div class="mp-bis-newsletter">' +
        '<input id="mp-bis-newsletter" type="checkbox" checked>' +
        '<label for="mp-bis-newsletter">Sign up for 15% off your first order</label>' +
        '</div>' +
        '<p class="mp-bis-error" hidden></p>' +
        '<p class="mp-bis-success" hidden>You\'re in! We\'ll let you know when it\'s back.</p>' +
        '<button type="submit" class="mp-bis-submit">NOTIFY ME WHEN AVAILABLE</button>' +
        '</form>' +
        '</div>';
      document.body.appendChild(modal);
    }
    bindModalEvents(modal);
    return modal;
  }

  function showModal(options) {
    var modal = ensureModal();
    var variantId = options && options.variantId;
    if (!variantId) return false;

    modal.dataset.variantId = String(variantId);
    var title = modal.querySelector('#mp-bis-title');
    if (title) title.textContent = (options && options.productName) || 'This product';
    var errorEl = modal.querySelector('.mp-bis-error');
    var successEl = modal.querySelector('.mp-bis-success');
    var emailInput = modal.querySelector('#mp-bis-email');
    if (errorEl) errorEl.hidden = true;
    if (successEl) successEl.hidden = true;
    if (emailInput) emailInput.value = '';

    modal.hidden = false;
    modal.classList.add('is-open');
    modal.style.display = 'flex';
    modal.style.background = 'rgba(0,0,0,0.45)';
    document.body.classList.add('mp-klaviyo-bis-open');
    /* Hide native Klaviyo iframe if it also tried to open — keep only our modal */
    var nativeIframe = document.getElementById('klaviyo-bis-iframe');
    if (nativeIframe) {
      nativeIframe.style.display = 'none';
      nativeIframe.style.visibility = 'hidden';
    }

    setTimeout(function () {
      if (emailInput) emailInput.focus();
    }, 50);
    return true;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  window.__mpOpenKlaviyoBis = function (options) {
    options = options || {};
    if (!options.variantId) return false;
    return showModal({
      variantId: options.variantId,
      productName: options.productName || 'This product',
    });
  };

  window.__mpCloseKlaviyoBis = closeModal;
})();
